export default "__VITE_ASSET__BeiraX4b__"